import { curEnvConfigAppInfoDict } from '../config'

export function getSubAppUrlErpChangePasswd() {
  return curEnvConfigAppInfoDict?.erp?.entry + '/#/basic_authentication?type=inner'
}

export function getSubAppUrlErpForgetPasswd() {
  return curEnvConfigAppInfoDict?.erp?.entry + '/#/basic_authentication?type=outer'
}
